import appConfigs from "@configs/app";
import httpClient from "@plugins/http";

const SIGNED_COOKIE_PATH = "/signed-cookie";

interface SignedCookieRequestOptions {
  headers: { Authorization: string };
  withCredentials: true;
  timeout?: number;
}

const signedCookieUrl = (): string => `${appConfigs.s3HtmlDomain}${SIGNED_COOKIE_PATH}`;

const authorizedRequest = (token: string, timeout?: number): SignedCookieRequestOptions => ({
  headers: { Authorization: `Bearer ${token}` },
  withCredentials: true,
  ...(timeout === undefined ? {} : { timeout }),
});

export default {
  async requestSignedCookie(token: string, timeout?: number): Promise<void> {
    await httpClient.post(signedCookieUrl(), undefined, authorizedRequest(token, timeout));
  },

  async deleteSignedCookie(token: string, timeout?: number): Promise<void> {
    await httpClient.delete(signedCookieUrl(), authorizedRequest(token, timeout));
  },
};
